(ns common.visibility
  (:require [common.rules :as rules]))

(def visibility-keys [:visibility/always :visibility/hidden :visibility/conditional])
(defn icon
  [visibility]
  (case visibility
    :visibility/always "fa-sharp fa-solid fa-eye"
    :visibility/hidden "fa-sharp fa-solid fa-eye-slash"
    :visibility/conditional "fa-sharp fa-solid fa-eye-low-vision"
    "fa-solid fa-unknown"))

(defn calc-visibility
  [value-lookup visibility-rules visibility]
  (case visibility
    :visibility/always      true
    :visibility/hidden      false
    :visibility/conditional (rules/rules-pass? value-lookup visibility-rules)
    false))
